<template>
    <div>

        <form :data-vv-scope="scopeForm" :method="methodForm" @submit.prevent="() => { }">

            <b-row>

                <!-- datos de la columna -->
                <b-col sm="12" md="6">
                    <b-card>

                        <b-card-title>
                            <strong>Información de la columna</strong>
                        </b-card-title>

                        <b-row>

                            <b-col sm="12" md="6" class="mt-3">
                                <label for="name">Nombre</label>
                                <input data-vv-as=" " v-validate="'required|max:255'" type="text" id="name" name="name"
                                    v-model="column.name" class="form-control" placeholder="Nombre"
                                    :class="{ 'is-invalid': errors.first(scopeForm + '.name') }" />
                                <span class="text-danger small" v-if="errors.first(scopeForm + '.name')">Debe ingresar un nombre</span>
                            </b-col>

                            <b-col sm="12" md="6" class="mt-3">
                                <label for="color">Color</label>
                                <input type="color" v-model="column.color" class="form-control form-control-color" />
                            </b-col>

                            <b-col sm="12" md="6" class="mt-3">
                                <label for="head">Seccioń</label>
                                <select :disabled="scopeForm === 'update'" class="custom-select" v-model="column.slq_inventory_section_id"
                                    v-validate="'required'" id="slq_inventory_section_id" name="slq_inventory_section_id"
                                    :class="{ 'is-invalid': errors.first(scopeForm + '.slq_inventory_section_id') }">
                                    <option v-for="item in getSections" :key="item.id" :value="item.id">
                                        {{ item.name }}
                                    </option>
                                </select>
                                <span class="text-danger small" v-if="errors.first(scopeForm + '.slq_inventory_section_id')">Debe seleccionar una sección</span>
                            </b-col>

                            <!-- Orden -->
                            <b-col sm="12" md="6" v-if="scopeForm === 'update'" class="mt-3">
                                <label for="head">Orden</label>
                                <b-button v-if="column.name === 'Contador'" variant="link">1</b-button>
                                <b-form-select v-else class="form-control" v-model="column.order_column"
                                    :options="column.order_available">
                                </b-form-select>
                            </b-col>

                        </b-row>

                    </b-card>
                </b-col>

                <!-- datos relacioandos a compos de peligros asociados a la seccion -->
                <b-col sm="12" md="6">
                    <ConfigFieldDangers />
                </b-col>

            </b-row>

        </form>

        <div v-if="column && column.inventory_section && !column.inventory_section.is_protected || !column.inventory_section">
            <ContentBtns :scopeForm="scopeForm" @onAction="onHandlerAction" />
        </div>        

    </div>
</template>

<script>

// Generales
import { mapState, mapActions, mapMutations } from "vuex";

import ConfigFieldDangers from "./ConfigFieldDangers.vue";
import ContentBtns from "./ContentBtns.vue";

export default {

    components: {
        ConfigFieldDangers,
        ContentBtns,
    },

    name: "Form",

    props: {
        scopeForm: {
            type: String,
            required: false,
            default: "create",
        },
        methodForm: {
            type: String,
            required: false,
            default: "POST",
        }
    },

    async mounted() {
        if (this.scopeForm === "create") {
            this.resetColumn();
        }
        await this.listAllSections();
    },

    computed: {
        ...mapState("colums", ["column", "dataSections"]),

        getSections() {
            return this.scopeForm === 'update' ? this.dataSections : this.dataSections.filter(section => !section.is_protected)
        }
    },

    methods: {

        ...mapActions("sections", ["listAllSections"]),
        ...mapMutations("colums", ["resetColumn"]),

        onHandlerAction() {
            this.$emit('onAction', this.scopeForm);
        },
    },

}
</script>